<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { submitResponses, buildPayload, GA4Events } from '../../services/api.js';
  
  export let captureType = 'transactional'; // 'transactional' or 'marketing'
  
  let email = '';
  let error = '';
  let submitting = false;
  
  $: isTransactional = captureType === 'transactional';
  $: title = isTransactional ? "We'll send your <em>match to you.</em>" : "Stay <em>connected.</em>";
  $: body = isTransactional
    ? "Enter your email and we'll send your personalized membership recommendation — your matched plan, benefits, and next steps — straight to your inbox."
    : "We'll keep you updated on team news, product availability, and access to the team before it goes public. No pressure — just the best seat in the inbox.";
  $: buttonText = isTransactional ? 'Send →' : 'Stay in →';
  
  async function handleSubmit() {
    // Validate email
    if (!email || !email.includes('@')) {
      error = 'Please enter a valid email address';
      return;
    }
    
    error = '';
    submitting = true;
    
    try {
      // Get current state
      let state;
      surveyStore.subscribe(s => state = s)();
      
      // Save email to store
      surveyStore.setEmail(email, captureType);
      
      // Track GA4 event
      GA4Events.emailCaptured(captureType, state.recommendation);
      
      // Build and submit payload to backend
      const payload = buildPayload(
        state.answers,
        state.recommendation,
        email,
        captureType
      );
      
      await submitResponses(payload);
      
      // Show success screen
      surveyStore.goToScreen('success', 5);
      
    } catch (err) {
      console.error('Error submitting email:', err);
      error = 'Something went wrong. Please try again.';
      submitting = false;
    }
  }
  
  function handleBack() {
    surveyStore.goToScreen('result', 5);
  }
</script>

<div class="card">
  <h2 class="card-title" style="font-size:1.5rem">{@html title}</h2>
  <div class="card-body">
    <p>{body}</p>
  </div>
  
  <div class="email-input-wrap">
    <input
      type="email"
      class="email-input"
      placeholder="your@email.com"
      bind:value={email}
      on:keypress={(e) => e.key === 'Enter' && handleSubmit()}
      disabled={submitting}
      style={error ? 'border-color: var(--danger)' : ''}
    />
    <button 
      class="email-submit" 
      on:click={handleSubmit}
      disabled={submitting}
    >
      {submitting ? '...' : buttonText}
    </button>
  </div>
  
  {#if error}
    <p style="color: var(--danger); font-size: 0.85rem; margin-top: 0.5rem;">
      {error}
    </p>
  {/if}
  
  <button class="back-btn" style="margin-top: 1.25rem;" on:click={handleBack}>
    ← Back
  </button>
</div>
